<app-academies-header></app-academies-header>
<section class="body-section">
    <div class="container">
        <main>
            <p-toast key="toastmsg"></p-toast>
            <div class=" col-md-12 bottom-container tablesections" data-aos="fade-up">
                <div class="header-container box w-100 " data-aos="fade-up" data-aos-delay="0">
                    <div class="container mobile-p-none">
                        <div class="row flex-lg-nowrap">
                            <div class="col mobile-p-none ">
                                <div class="row">
                                    <div class="col mb-3 mobile-p-none ">
                                        <div class="card">
                                            <div class="card-body">
                                                <h2 class="title-stide">Academy Gallery</h2>
                                                <div class="slider-images-div">
                                                    <div class="tab-content pt-3" data-aos="fade-up"
                                                        data-aos-delay="400">
                                                        <div class="tab-pane active">
                                                            <div class="upload__box">
                                                                <div class="upload__btn-box">
                                                                    <label class="upload__btn">
                                                                        <p> <i class='bx bx-cloud-upload'></i>
                                                                            <span class="main-title-div"> Upload
                                                                                Academy Gallery Image</span>
                                                                            <span class="t-text">
                                                                                PNG and JPG files only
                                                                            </span>

                                                                            <!-- <span class="t-text">
                                                                                <div class=" pb-0">
                                                                                    <strong>Instructions: </strong>Image
                                                                                    dimension
                                                                                    should
                                                                                    be width:1200px and height:450px.
                                                                                </div>
                                                                            </span> -->



                                                                        </p>
                                                                        <p-fileUpload multiple="multiple"
                                                                            maxFileSize="{{imageSize}}"
                                                                            customUpload="true" name="myfile[]"
                                                                            (uploadHandler)="picUploader($event)"
                                                                            accept="image/*" auto="auto">
                                                                        </p-fileUpload>

                                                                        <!-- <input type="file" multiple=""
                                                                            data-max_length="20"
                                                                            class="upload__inputfile"> -->
                                                                    </label>
                                                                </div>
                                                                <div class="col-md-12 text-center" *ngIf="showPicError">
                                                                    <div *ngIf="showPicError" class="">
                                                                        <div *ngIf="showPicError" style="color:red;">
                                                                            Please upload
                                                                            Academy Gallery.</div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-12 e-profile">
                                                                    <div class="col d-flex justify-content-center">
                                                                        <button class="btn btn-primary"
                                                                            (click)="onSubmit('')">Save
                                                                            Changes</button>
                                                                    </div>
                                                                </div>
                                                                <div class="upload__img-wrap">
                                                                    <h2 class="title-stide">Uploaded Images</h2>
                                                                    <swiper class="swiper-wrapper" fxFlex="auto"
                                                                        [config]="court_config" [disabled]="disabled"
                                                                        (indexChange)="onIndexChange($event)"
                                                                        (swiperTransitionStart)="onSwiperEvent('transitionStart')"
                                                                        (swiperTransitionEnd)="onSwiperEvent('transitionEnd')">
                                                                        <div *ngFor="let slider of imageslider "
                                                                            class="swiper-slide">
                                                                            <div class="blog_card">
                                                                                <div class="edit-button-show-click">
                                                                                    <button type="button"
                                                                                        class="banner_trash-btn btn-danger"
                                                                                        pButton pRipple
                                                                                        icon="pi pi-trash"
                                                                                        (click)="removeImages(slider)"
                                                                                        title="Delete"></button>
                                                                                </div>
                                                                                <div class="image">
                                                                                    <img src="{{slider.slider_image_src}}"
                                                                                        alt="">
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </swiper>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</section>
<p-confirmDialog [style]="{width:'450px'}"></p-confirmDialog>